<div class="form-element">
  <div class="d-flex justify-content-between align-items-center">
    <label>{{ label }}</label>

    @if (tooltip) {
      <div class="tooltip-content">
        <i class="fas fa-info-circle"></i>
        <app-tooltip position="tr">
          <p>{{ tooltip }}</p>
        </app-tooltip>
      </div>
    }
  </div>

  @if (!disabled && control?.value?.length <= maxCount - 1) {
    <cap-file-upload
      styleClass="g-uploader no-print"
      [id]="getControlName()"
      [label]="''"
      [multiple]="multiple"
      [accept]="fileExtensions"
      [uploaderContent]="uploadContent"
      (onFileChange)="addFile($event)">
    </cap-file-upload>
  }

  @if (control?.value?.length > maxCount) {
    <div class="upload prime-file-upload">
      <i class="fas fa-cloud-upload-alt"></i>
      <span>
        {{ 'dental.validation.count.file' | translate: { count: maxCount } }}
      </span>
    </div>
  }

  <div class="preview--section">
    @if (!hasPopup) {
      <app-previewer
        [showLoader]="showLoader"
        [items]="totalScans"
        [deletable]="!disabled"
        [showThumbnail]="showThumbnail"
        (cardClick)="cardClick?.emit($event)"
        (removeClick)="deleteFile($event)">
      </app-previewer>
    }

    @if (hasPopup) {
      <app-previewer-popup
        [showLoader]="showLoader"
        [items]="control?.value"
        [deletable]="!disabled"
        [showThumbnail]="showThumbnail"
        (cardClick)="cardClick?.emit($event)"
        (removeClick)="deleteFile($event)">
      </app-previewer-popup>
    }

    <app-scans-download-status (downloadedScans)="setDownloadedScans($event)"></app-scans-download-status>
  </div>

  <ng-template #uploadContent>
    @if (!disabled) {
      <div class="upload">
        <i class="fas fa-cloud-upload-alt"></i>
        <p class="d-none d-lg-block" [innerHTML]="description ? description : label"></p>
        <p class="d-lg-none">{{ 'file.upload.label' | translate }}</p>
      </div>
    }
  </ng-template>

  @if (control) {
    <cap-validator [control]="control" [customName]="label"></cap-validator>
  }
</div>

<p-confirmDialog #confirmDialog [header]="label" [closable]="false">
  <ng-template #footer>
    <cap-button [label]="'general.yes' | translate" styleClass="primary" (click)="confirmDialog.onAccept()">
    </cap-button>
  </ng-template>
</p-confirmDialog>
